import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./loginCard.html";
import { ENV_TYPES, SOURCE_LOGIN_CARD_NUMBER, TARGET_LOGIN_CARD_NUMBER } from '../utils/appConstants';
const {
  SANDBOX,
  PRODUCTION
} = ENV_TYPES;
class LoginCard extends LightningElement {
  constructor(...args) {
    super(...args);
    this.cardNumber = void 0;
    this.cardTitle = void 0;
    this.connectToOrgtitle = void 0;
    this.disableCard = false;
    this.showFileUpload = false;
    this.envType = SANDBOX;
    this.value = SANDBOX;
    this.cardNumberPath = '/resources/Badge-1.svg';
    this.handleEnvChange = event => {
      this.envType = event.detail.value;
    };
    this.handleConnectToOrg = event => {
      event.preventDefault();
      const details = {
        'envType': this.envType,
        'cardNumber': this.cardNumber
      };
      const selectedEvent = new CustomEvent('connecttoorg', {
        detail: details
      });
      this.dispatchEvent(selectedEvent);
    };
    this.handleUploadFile = event => {
      event.preventDefault();
      const files = event.target.files;
      const selectedEvent = new CustomEvent('uploadfile', {
        detail: files
      });
      this.dispatchEvent(selectedEvent);
      event.target.value = '';
    };
  }
  connectedCallback() {
    //update card number's img
    const me = this;
    if (me.cardNumber === SOURCE_LOGIN_CARD_NUMBER) {
      me.cardNumberPath = '/resources/Badge-1.svg';
    } else if (me.cardNumber === TARGET_LOGIN_CARD_NUMBER && !me.disableCard) {
      me.cardNumberPath = '/resources/Badge-2.svg';
    } else {
      me.cardNumberPath = '/resources/Badge-2-disabled.svg';
    }
  }
  get envTypes() {
    return [{
      label: 'Sandbox',
      value: SANDBOX
    }, {
      label: 'Production',
      value: PRODUCTION
    }];
  }
}
_registerDecorators(LoginCard, {
  publicProps: {
    cardNumber: {
      config: 0
    },
    cardTitle: {
      config: 0
    },
    connectToOrgtitle: {
      config: 0
    },
    disableCard: {
      config: 0
    },
    showFileUpload: {
      config: 0
    }
  },
  fields: ["envType", "value", "cardNumberPath", "handleEnvChange", "handleConnectToOrg", "handleUploadFile"]
});
export default _registerComponent(LoginCard, {
  tmpl: _tmpl
});